import { apiClient } from './client';
import type {
  Tenant,
  TenantCreateInput,
  TenantUpdateInput,
} from '../../types/entities';

export const tenantsApi = {
  /**
    * Get all tenants
    * GET /tenants
    */
  getAll: async (): Promise<Tenant[]> => {
    return apiClient.get<Tenant[]>('/tenants');
  },

  /**
    * Get a single tenant by ID
    * GET /tenants/:id
    */
  getById: async (id: number): Promise<Tenant> => {
    return apiClient.get<Tenant>(`/tenants/${id}`);
  },

  /**
    * Create a new tenant
    * POST /tenants
    */
  create: async (data: TenantCreateInput): Promise<Tenant> => {
    return apiClient.post<Tenant>('/tenants', data);
  },

  /**
    * Update a tenant
    * PUT /tenants/:id
    */
  update: async (id: number, data: TenantUpdateInput): Promise<Tenant> => {
    return apiClient.put<Tenant>(`/tenants/${id}`, data);
  },

  /**
    * Delete a tenant
    * DELETE /tenants/:id
    */
  delete: async (id: number): Promise<void> => {
    return apiClient.delete<void>(`/tenants/${id}`);
  },
};
